export const soundDatas = [
  {
    id: 1,
    title: "Rainfall",
    volume: 0,
    isActive: false,
    path: "https://pub-82d7442bab8d452c85c1ae19021bb34a.r2.dev/rain-min.mp3"
  },
  {
    id: 2,
    title: "Breeze",
    volume: 0,
    isActive: false,
    path: "https://pub-82d7442bab8d452c85c1ae19021bb34a.r2.dev/wind-min.mp3"
  },
  {
    id: 3,
    title: "Forest",
    volume: 0,
    isActive: false,
    path: "https://pub-82d7442bab8d452c85c1ae19021bb34a.r2.dev/forest-min.mp3"
  },
  // {
  //   id: 4,
  //   title: "City",
  //   volume: 0,
  //   isActive: false,
  //   path: "/audios/city.mp3"
  // },
  {
    id: 4,
    title: "40Hz Binaural Beats",
    volume: 0,
    isActive: false,
    path: "https://pub-82d7442bab8d452c85c1ae19021bb34a.r2.dev/boost-min.mp3"
  },
  // {
  //   id: 6,
  //   title: "Singing birds",
  //   volume: 0,
  //   isActive: false,
  //   path: "/audios/singing_birds.mp3"
  // },
];
